export const BRAND = "TheInner.app";
export const CALENDLY_URL = "https://calendly.com/avnni/private-consultation";
export const CONSULT_PRICE = "$99/hour";
export const CONSULTANT_NAME = "Avnni";

export const CATEGORY_ORDER = ["Relationships", "Self-Discovery", "Purpose", "Growth", "Wellbeing"];
